import styled from 'styled-components'

export const StyledDropdown = styled.div`
  position: relative;
  width: 100%;
`

export const Menu = styled.div``
